// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"ff444c7cc7f412be080c","682":"56829b2930024383b63a","883":"9c26c33dad1f6bc04849"}[chunkId] + ".js";
};